export enum SubscriberStatusType {
  NONE = "NONE",
  UN_PAID = "UN_PAID",
  PROCEEDING = "PROCEEDING",
  CANCELING = "CANCELING",
  STOP = "STOP"
}
